import { FunctionComponent } from 'react';

import styled from 'styled-components';

import { FileModel } from 'models';

import { FileUrlService } from 'features/exam/services/file-url-service';

export const AudioViewer: FunctionComponent<{ file: FileModel; accessToken: null | string }> = ({ file, accessToken }) => {
  const audioUrl = FileUrlService.resolveFileUrl(file, accessToken);

  // Get file extension to determine MIME type
  const getAudioMimeType = (filename: string): string => {
    const extension = filename.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'wav':
        return 'audio/wav';
      case 'ogg':
        return 'audio/ogg';
      case 'aac':
        return 'audio/aac';
      case 'flac':
        return 'audio/flac';
      case 'm4a':
        return 'audio/mp4';
      case 'opus':
        return 'audio/opus';
      case 'webm':
        return 'audio/webm';
      default:
        return 'audio/mpeg'; // Default fallback
    }
  };

  const mimeType = getAudioMimeType(file.fileName || '');

  return (
    <StyledAudioWrapper>
      <audio controls preload="metadata">
        <source src={audioUrl} type={mimeType} />
        Your browser does not support the audio element.
      </audio>
      <div className="file-info">
        <span className="filename">{file.fileName}</span>
      </div>
    </StyledAudioWrapper>
  );
};

const StyledAudioWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;

  audio {
    width: 100%;
    max-width: 600px;
  }

  .file-info {
    text-align: center;

    .filename {
      font-size: 1rem;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.palette.grayscale[7] ?? '#333'};
    }
  }
`;
